import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { postCliente } from "../../redux/clientes/clientesAction";
import "../../index.css"

export default function ClienteNuevo(){
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [form, setForm] = useState({
        numCliente: "",
        nombre:"",
        apellido:"",
        cuitCuilDni:"",
        ciudad:"",
        direccion:"",
        cp:"",
        zona:"",
        telefono:"",
        notas:""
    });
    
    const handleChange = (e) => {
        const {value} = e.target
        setForm({
            ...form,
            [e.target.name]: value
        })
    }

    const handleSubmit = () => {
        // if (codArticulo === ""
        //     || nombre === ""
        //     || ciclo === ""
        //     || isbn === ""
        //     || precio === ""){
                
        //     }
        dispatch(postCliente(form))

    }

    return (
        <>
            <div className="bg-custom container-custom">
                <div className="text-orange-500">
                <div>
                    <p className="text-[14pt] font-semibold">Nuevo Cliente</p>                    
                </div>
                <div className="mt-8">
                    <div className="flex mb-4">
                        <label className="w-[150px] font-semibold">Nombre</label>
                        <input
                            className="w-[300px] text-center bg-slate-700 no-spinner"
                            type="text"
                            name="nombre"
                            value={form.nombre}
                            onChange={handleChange}
                        />
                    </div>  
                    <div className="flex mb-4">
                        <label className="w-[150px] font-semibold">Apellido</label>
                        <input
                            className="w-[300px] text-center bg-slate-700"
                            type="text"
                            name="apellido"
                            value={form.apellido}
                            onChange={handleChange}
                        />
                    </div>  
                    <div className="flex mb-4">
                        <label className="w-[150px] font-semibold">CUIT / CUIL / DNI</label>
                        <input
                            className="w-[300px] text-center bg-slate-700"
                            type="text"
                            name="cuitCuilDni"
                            value={form.cuitCuilDni}
                            onChange={handleChange}
                        />
                    </div>  
                    <div className="flex mb-4">
                        <label className="w-[150px] font-semibold">Ciudad</label>
                        <input
                            className="w-[300px] text-center bg-slate-700"
                            type="text"
                            name="ciudad"
                            value={form.ciudad}
                            onChange={handleChange}
                        />
                    </div>  
                    <div className="flex mb-4">
                        <label className="w-[150px] font-semibold">Direccion</label>
                        <input
                            className="w-[300px] text-center bg-slate-700 no-spinner"
                            type="text"
                            name="direccion"
                            value={form.direccion}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="flex mb-4">
                        <label className="w-[150px] font-semibold">CP</label>
                        <input
                            className="w-[300px] text-center bg-slate-700 no-spinner"
                            type="text"
                            name="cp"
                            value={form.cp}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="flex mb-4">
                        <label className="w-[150px] font-semibold">Zona</label>
                        <input
                            className="w-[300px] text-center bg-slate-700 no-spinner"
                            type="text"
                            name="zona"
                            value={form.zona}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="flex mb-4">
                        <label className="w-[150px] font-semibold">Telefono</label>
                        <input
                            className="w-[300px] text-center bg-slate-700 no-spinner"
                            type="text"
                            name="telefono"
                            value={form.telefono}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="flex mb-4">
                        <label className="w-[150px] font-semibold">Notas</label>
                        <input
                            className="w-[300px] text-center bg-slate-700 no-spinner"
                            type="text"
                            name="notas"
                            value={form.notas}
                            onChange={handleChange}
                        />
                    </div>         
                </div>
                <div>
                    <button className="mt-10 rounded text-black font-bold w-[100px] h-[50px] bg-sky-400 hover:bg-sky-100 hover:text-gray-400"
                        onClick={handleSubmit}>
                        Crear Cliente
                    </button>
                </div>
                </div>
            </div>
        </>
    )
}